import FlatTreeInput from '../../FlatTreeInput';
import FlatTreeSelect from '../../FlatTreeSelect';

interface IAddFlatNodeValuesForm {
	isAvailableValuesMode: boolean;
	nodeAvailableValues: string[];
	selectValueRef: React.RefObject<HTMLSelectElement>;
	value: string | undefined;
	setValue: React.Dispatch<React.SetStateAction<string | undefined>>;
	validateInput?: (value: string) => boolean;
}

const AddFlatNodeValuesForm = ({
	isAvailableValuesMode,
	nodeAvailableValues,
	selectValueRef,
	value,
	setValue,
	validateInput,
}: IAddFlatNodeValuesForm) => {
	return isAvailableValuesMode ? (
			<FlatTreeSelect
				options={nodeAvailableValues}
				selectRef={selectValueRef}
			/>
		) : (
			<FlatTreeInput
				inputValue={value}
				setInputValue={setValue}
				testName='add_node_value'
				validateInput={validateInput}
			/>
		);
};

export default AddFlatNodeValuesForm;
